import React from 'react';

export const NoDataMessage = ( ) => {
  return <div className="flex justify-center text-primary text-sm font-semibold">データがありません</div>
}